/* eslint-disable */
import React from "react";
import {
  Button,
  Center,
  Group,
  Modal,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import ModalHeader from "components/ModalHeader";
import { IconTrash } from "@tabler/icons-react";
import { useDeleteDepartment } from "api/department/deleteDepartment";
import { showNotification } from "@mantine/notifications";

type DeleteDepartmentProps = {
  opened: boolean;
  departmentId?: string | null;
  onClose: () => void;
};

export default function DeleteDepartment({
  opened,
  onClose,
  departmentId,
}: DeleteDepartmentProps) {
  const deleteMutation = useDeleteDepartment();

  const handleConfirm = () => {
    if (!departmentId) {
      showNotification({
        title: "Error",
        message: "No department selected to delete",
        color: "red",
      });
      return;
    }

    deleteMutation.mutate(departmentId, {
      onSuccess: () => {
        onClose();
      },
      onError: () => {},
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
      aria-labelledby="confirm-delete-title"
      aria-describedby="confirm-delete-desc"
    >
      <ModalHeader
        title="Delete Department"
        onClose={onClose}
        ariaLabel="Close delete department modal"
      />

      <div>
        <Center>
          <ThemeIcon
            size={48}
            radius="md"
            sx={(theme) => ({
              color: theme.colors.red[6],
              backgroundColor: "transparent",
            })}
          >
            <IconTrash size={24} />
          </ThemeIcon>
        </Center>

        <Stack align="center" spacing={4} mt="md">
          <Title id="confirm-delete-title" order={3}>
            Confirm Delete
          </Title>

          <Text
            id="confirm-delete-desc"
            align="center"
            color="dimmed"
            size="sm"
          >
            Are you sure you want to delete this department? This action cannot
            be undone.
          </Text>

          <Group position="center" spacing="md" mt="md">
            <Button
              // variant="default"
              color="cancel"
              onClick={onClose}
              disabled={deleteMutation.isLoading}
            >
              Cancel
            </Button>

            <Button
              color="red"
              onClick={handleConfirm}
              loading={deleteMutation.isLoading}
              disabled={!departmentId || deleteMutation.isLoading}
            >
              Yes, Delete
            </Button>
          </Group>
        </Stack>
      </div>
    </Modal>
  );
}
